var irreducible = require('./irreducible');

module.exports = irreducible('Any', function () { return true; });



/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb-form-templates-bootstrap/~/tcomb/lib/Any.js
 ** module id = 69
 ** module chunks = 0
 **/